var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.60204 5.72647C9.5498 5.67417 9.48776 5.63269 9.41947 5.60438C9.35119 5.57607 9.27799 5.5615 9.20407 5.5615C9.13015 5.5615 9.05695 5.57607 8.98866 5.60438C8.92038 5.63269 8.85834 5.67417 8.8061 5.72647L3.1811 11.3515C3.12886 11.4038 3.08738 11.4658 3.05907 11.5341C3.03076 11.6024 3.01619 11.6756 3.01619 11.7495C3.01619 11.8234 3.03076 11.8966 3.05907 11.9649C3.08738 12.0332 3.12886 12.0952 3.1811 12.1475C3.23335 12.1998 3.29539 12.2413 3.36368 12.2696C3.43196 12.2979 3.50516 12.3125 3.57908 12.3125C3.653 12.3125 3.7262 12.2979 3.79448 12.2696C3.86277 12.2413 3.92481 12.1998 3.97706 12.1475L9.20407 6.91974L14.4311 12.1475C14.5366 12.253 14.6797 12.3123 14.829 12.3123C14.9783 12.3123 15.1214 12.253 15.227 12.1475C15.3325 12.042 15.3918 11.8988 15.3918 11.7495C15.3918 11.6002 15.3325 11.4571 15.227 11.3515L9.60204 5.72647Z",
    fill: "#2E221F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUp);
export default __webpack_public_path__ + "static/media/arrowUp.8adb6ddf06a1b6cd422f9c257194cb30.svg";
export { ForwardRef as ReactComponent };